/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResendWelcomeEmailRequest
 */
export interface ResendWelcomeEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendWelcomeEmailRequest
     */
    iamUserId: string;
}

export function ResendWelcomeEmailRequestFromJSON(json: any): ResendWelcomeEmailRequest {
    return ResendWelcomeEmailRequestFromJSONTyped(json, false);
}

export function ResendWelcomeEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendWelcomeEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamUserId': json['iam_user_id'],
    };
}

export function ResendWelcomeEmailRequestToJSON(value?: ResendWelcomeEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_user_id': value.iamUserId,
    };
}


